module.exports = __webpack_public_path__ + "img/pass-it-down-tablet_724x500.a5613637.jpg";